import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { UpdateRecurringMeetingFromInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const UpdateRecurringMeetingFromMutation = graphql(`
  mutation UpdateRecurringMeetingFrom($input: UpdateRecurringMeetingFromInput!) {
    updateRecurringMeetingFrom(input: $input) {
      id
      __typename
      cadence
      startDate
      until
      scheduledStartTime
      scheduledEndTime
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useUpdateRecurringMeetingFrom() {
  const [result, updateRecurringMeetingFromMutation] = useMutation(UpdateRecurringMeetingFromMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateRecurringMeetingFrom = useCallback(
    async (input: UpdateRecurringMeetingFromInput) => {
      try {
        const response = await updateRecurringMeetingFromMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.updateRecurringMeetingFrom;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [updateRecurringMeetingFromMutation],
  );

  return { updateRecurringMeetingFrom, result, error };
}
